import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IPropertyFormByIdRouteProps extends PropsWithChildren {
    propertyId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const PropertyFormByIdRoute: FC<IPropertyFormByIdRouteProps> = ({
    propertyId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const propertyIdToUse = (params.propertyId ? +params.propertyId : undefined) ?? propertyId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={propertyIdToUse}
            formDefinitionIdentifier={FormDefinitions.Property}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default PropertyFormByIdRoute;
